import {getBackendURL, httpResponse, httpResponseError} from "../../fn";
import axios from "axios";

import {dealData} from "./deal";

/**
 *
 * @param formData
 * @returns {Promise<UploadSigFileResult>}
 */
export const uploadSigDocument = async (id, formData) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/documents/${id}/upload/sig`, formData, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    });
  })

  if (result.ok) {
    dealData.documents.map((item) => {
      item.id === id ? item.signlink = result.data.signlink : void 0;
    })
  }

  return result;
}

/**
 *
 * @param documentId   /:documentId/deal/:dealId/validate/signature/
 * @returns {Promise<unknown>}
 */
export const validateSigDocument = async (dealId, documentId) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/documents/${documentId}/deal/${dealId}/validate/signature`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then(function (response) {
      if (response.status === 200) {
        resolve(httpResponse(response.data));
      }
    })
      .catch(function (error) {
        resolve(httpResponseError(error));
      });
  })

  return result;
}

/**
 *
 * @param values
 * @returns {Promise<{data: *, ok: boolean} | {statusText: *, ok: boolean, message: string, status: *, errors: Array}>}
 */
export const updateDocuments = async (values) => {
  const result = axios.put(`${getBackendURL()}/documents/${values.id}`, values, {
    withCredentials: true,
    headers: {
      'content-type': 'application/json',
    },
  })
    .then(function (response) {
      if (response.status === 200) {
        return httpResponse({});
      }
    })
    .catch(function (error) {
      return httpResponseError(error);
    });

  return result;
}

/**
 *
 * @param id - ид документа в сделке
 * @returns {Promise<unknown>}
 */
export const deleteDocumentFromDeal = async (id) => {
  const fileIdx = dealData.documents.findIndex((item) => item.id === id);
  dealData.documents.splice(fileIdx, 1);

  // удаляем ссылку на документ у всех участников
  /* this.participants.map((item) => {
     const idx = item.documentsRef?.indexOf(id);
     if (idx)
       item.documentsRef.splice(idx, 1);
   })*/

  const result = await new Promise((resolve) => {
    axios.delete(`${getBackendURL()}/documents/${id}`, {
      withCredentials: true
    })
      .then((response) => {
        resolve(httpResponse({}))
      })
      .catch(function (error) {
        resolve(httpResponseError(error));
      });
  })

  return result;
}

/**
 *
 * @param id - ид документа в сделке
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const generateBankDruzhbaNotify = async () => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/documents/druzhba/notify/deal/${dealData.dealId}`, {
      withCredentials: true
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch(function (error) {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Создание пдф заявлений
 * @param id - ид документа в сделке
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const rendXmlStatements = async () => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/documents/rend/statement/deal/${dealData.dealId}`, {
      withCredentials: true
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch(function (error) {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 *
 * @param participantId
 * @returns {Promise<unknown>}
 */
export const generateNonMarriageStatement = async (participantId) => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/documents/nonmarriage/deal/${dealData.dealId}/participant/${participantId}`, {
      withCredentials: true
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch(function (error) {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 *
 * @param participantId
 * @returns {Promise<unknown>}
 */
export const generateReceiptSendForStateReg= async () => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/documents/receipt/deal/${dealData.dealId}`, {
      withCredentials: true
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch(function (error) {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 *
 * @param id - ид документа в сделке
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const generateBankNoospheraNotify = async () => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/documents/noosphera/notify/deal/${dealData.dealId}`, {
      withCredentials: true
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch(function (error) {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 *
 * @param formData
 * @returns {Promise<UploadFileResult>}
 */
export const uploadNewDocument = async (formData) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/documents/upload/deal/${dealData.dealId}`, formData, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then(function (response) {
      if (response.status === 200) {
        resolve(httpResponse(response.data));
      }
    }).catch(function (error) {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * загрузка нескольких документов
 * @returns {Promise<UploadFileResult>}
 * @param files
 */
export const uploadSeveralDocuments = async (files) => {
  const formData = new FormData();

  Array.from(files).forEach((file) => {
    formData.append('files', file);
  });

  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/documents/upload/files/deal/${dealData.dealId}`, formData, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then(function (response) {
      if (response.status === 200) {
        resolve(httpResponse(response.data));
      }
    }).catch(function (error) {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Возвращает список файлов в сделке в формате для select элемента
 * @returns {{value: string, key: *}[]}
 */
export const getDocumentsList = () => {
  const result = [];
  for (const doc of dealData.documents) {
    result.push({key: doc.id, value: doc.fileDesc || doc.fileName});
  }

  return result;
}


/**
 * Удалить ссылку на заявителя из списка ссылок документа
 */
export const rmSubjectsFromDocumentsRef = (documentId, participantId) => {
  if (!documentId)
    return
  const idx = dealData.documentsRefListToParticipants[documentId]?.indexOf(participantId)
  if (idx !== -1)
    dealData.documentsRefListToParticipants[documentId].splice(idx, 1);
}

/**
 * Генерим объект ссылок документов на участников сделки.
 * документ = [...ид участников]
 * на беке ссылки хранятся в участниках,
 * на фронте ссылки на участников выводятся в документах.
 */
export const loadDocRefs = () => {
  dealData.participants.map((item) => {
    if (!item.documentsRef)
      return

    const participantId = item.participantId;

    const addref = (documentId) => {
      if (!dealData.documentsRefListToParticipants[documentId]) {
        dealData.documentsRefListToParticipants[documentId] = [participantId]
      } else {
        dealData.documentsRefListToParticipants[documentId].push(participantId)
      }
    }

    item.documentsRef.map((documentId) => addref(documentId));
  })
}

/**
 * Прикрепляет ссылку на файл сделки к конкретному субъекту сделки
 * @param personId
 */
export const setDocRefToSubject = ({participantId, documentId}) => {
  dealData.participants.find((item) => {
    if (
      item.participantId === participantId &&
      !item.documentsRef?.includes(documentId)
    ) {
      item.documentsRef ? void 0 : item.documentsRef = [];
      item.documentsRef?.push(parseInt(documentId));
    }
  })

  if (!dealData.documentsRefListToParticipants[documentId]) {
    dealData.documentsRefListToParticipants[documentId] = [participantId]
  } else {
    dealData.documentsRefListToParticipants[documentId].push(participantId)
  }
}